@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
		header="{{ title | uppercase }}"
		[(visible)]="display"
		[responsive]="true"
		showEffect="fade"
		[modal]="true"
		appendTo="body"
	>
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<div class="container-md">
			@if (errorMessages.length !== 0) {
				<div>
					@for (error of errorMessages; track error) {
						<div>
							<div class="alert alert-warning" role="alert">{{ error }}</div>
						</div>
					}
				</div>
			}
			<!-- ROW 1: VEHICLE + DRIVER + REASON -->
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2"
						><strong>{{ 'general.vehicle' | translate }} (*)</strong></label
					>
					<div class="p-0"></div>
					<p-select
						[options]="vehicleList"
						[(ngModel)]="entity.vehicle"
						dataKey="id"
						optionLabel="name"
						placeholder="{{ 'general.select' | translate }} {{ 'general.vehicle' | translate }}"
						[style]="{ width: '250px' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeVehicle($event)"
						(onFilter)="onFilterVehicle($event)"
						[disabled]="!formManipulation || !editVehicle"
					>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2"
						><strong>{{ 'tableManagement.sinister.driver' | translate }} (*)</strong></label
					>
					<div class="p-0"></div>
					<p-select
						[options]="driverList"
						[(ngModel)]="entity.driver"
						dataKey="id"
						optionLabel="formatDriverLabel"
						placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.sinister.driver' | translate }}"
						[style]="{ width: '250px' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeDriver($event)"
						(onFilter)="onFilterDriver($event)"
						[disabled]="true"
					>
						<ng-template let-driver pTemplate="item">
							<div>
								({{ driver.employee.code }}) {{ driver.employee.user.surname1 }}
								{{ driver.employee.user.surname2 }} {{ driver.employee.user.name }}
							</div>
						</ng-template>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2"
						><strong>{{ 'tableManagement.sanction.reason' | translate }} (*)</strong></label
					>
					<div class="p-0"></div>
					<p-select
						[options]="sanctionReasonList"
						[(ngModel)]="entity.reason"
						dataKey="id"
						optionLabel="reason"
						placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.sanction.reason' | translate }}"
						[style]="{ width: '250px' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeReason($event)"
						(onFilter)="onFilterReason($event)"
						[disabled]="!formManipulation"
					>
					</p-select>
				</div>
			</div>
			<!-- ROW 2: DATE + ISSUER + RESPONSIBLE -->
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2"
						><strong>{{ 'tableManagement.sanction.date' | translate }} (*)</strong></label
					>
					<div class="p-0"></div>
					<p-datepicker
						[(ngModel)]="sanctionDate"
						[showTime]="false"
						[style]="{ width: '200px' }"
						dateFormat="{{ i18n.dateFormat }}"
						showIcon="true"
						appendTo="body"
						[disabled]="!formManipulation"
					>
					</p-datepicker>
				</div>
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2"
						><strong>{{ 'tableManagement.sanction.issuer' | translate }} (*)</strong></label
					>
					<div class="p-0"></div>
					<input
						type="text"
						class="form-control custom-input"
						[(ngModel)]="entity.issuer"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2">{{ 'tableManagement.sanction.responsible' | translate }}</label>
					<div class="p-0"></div>
					<p-select
						[options]="responsibleList"
						[(ngModel)]="entity.responsible"
						dataKey="id"
						optionLabel="formatResponsibleLabel"
						placeholder="{{ 'general.select' | translate }} {{
							'tableManagement.sanction.responsible' | translate
						}}"
						[style]="{ width: '250px' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeResponsible($event)"
						(onFilter)="onFilterResponsible($event)"
						[disabled]="!formManipulation"
					>
					</p-select>
				</div>
			</div>
			<!-- ROW 3: AMOUNT + POINTS + DISCOUNT PAYROLL -->
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2">{{ 'tableManagement.sanction.amount' | translate }}</label>
					<div class="p-0"></div>
					<input
						type="number"
						class="form-control custom-input"
						[(ngModel)]="entity.amount"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2">{{ 'tableManagement.sanction.points' | translate }}</label>
					<div class="p-0"></div>
					<input
						type="number"
						class="form-control custom-input"
						[(ngModel)]="entity.points"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2">{{ 'tableManagement.sanction.discountPayroll' | translate }}</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.discountPayroll" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
			</div>
			<!-- ROW 4: AMOUNT TO DISCOUNT -->
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label class="form-label custom-label fw-bold small mb-2 me-2">{{ 'tableManagement.sanction.amountToDiscount' | translate }}</label>
					<div class="p-0"></div>
					<input
						type="number"
						class="form-control custom-input"
						[(ngModel)]="entity.amountToDiscount"
						[disabled]="!formManipulation"
					/>
				</div>
			</div>
			<!-- TABS: OBSERVATIONS + DOCUMENTS -->
			<div class="container-fluid p-0 custom-panel">
				<div class="row m-0 mt-4">
					<ul class="nav nav-tabs custom-nav-tabs">
						@if (!isNew) {
							<li class="nav-item">
								<a
									href="#sanction-observations"
									class="nav-link active p-0 custom-title custom-tab-title first-nav-tab"
									data-bs-toggle="tab"
								>
									<div class="d-flex align-items-center justify-content-center h-100">
										{{ 'tableManagement.sinister.sinisterObservations' | translate }}
									</div>
								</a>
							</li>
						}
						@if (!isNew) {
							<li class="nav-item">
								<a
									href="#sanction-documents"
									class="nav-link p-0 custom-title custom-tab-title"
									[class.first-nav-tab]="isNew"
									data-bs-toggle="tab"
								>
									<div class="d-flex align-items-center justify-content-center h-100">
										{{ 'drivers.form.documents' | translate }}
									</div>
								</a>
							</li>
						}
					</ul>
				</div>
				<div class="row m-0">
					<div class="tab-content p-0">
						<div class="tab-pane fade show active" id="sanction-observations">
							<div class="container-fluid">
								@if (!isNew) {
									<div class="row mt-3">
										<app-observations-list
											type="SANCTION"
											[entityId]="entity.id"
											[ids]="idsObservations"
										></app-observations-list>
									</div>
								}
							</div>
						</div>
						<div class="tab-pane fade" id="sanction-documents">
							<div class="container-fluid">
								@if (!isNew) {
									<div class="row mt-3">
										<app-doc-table
											type="sanction"
											[entity]="entity"
											[nested]="true"
											[ids]="ids"
											(return)="refresh()"
										></app-doc-table>
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					<button class="btn custom-button" (click)="saveChanges()" [disabled]="!formManipulation">
						{{ (isNew ? 'general.create' : 'general.save') | translate }}
					</button>
				</div>
			</div>
		</ng-template>
</p-dialog>
}

